import React from "react";
import { Button, Form, Tab, Nav } from "react-bootstrap";
import Budgetoverviewtab from "./budgetoverviewtab/Budgetoverviewtab";
import './budgetoverview.css'
import Budgeclaimstab from "./budgeclaimstab/Budgeclaimstab";
import Budgetremittancestab from "./budgetremittancestab/Budgetremittancestab";
import Budgetreconciliationtab from "./budgetreconciliationtab/Budgetreconciliationtab";
import Budgetreporttab from "./budgetreporttab/Budgetreporttab";
import Budgetconnectionstab from "./budgetconnectionstab/Budgetconnectionstab";

const Budgetoverview: React.FC = () => {
    return (
        <>
            <div className="common_card">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Billing Center</h2>
                        <p>Seamless monthly flow: scrub → submit → reconcile → report. Simple SaaS design, zero clutter.</p>
                    </div>
                    <div className="top_right_flx">
                        <Button variant="primary" className="btn_sm">Export CSV</Button>
                    </div>
                </div>
                <div className="top top_bar_flx border_tittle mby_16 justify-content-end" style={{ paddingBottom: '1rem' }}>
                    <div className="top_right_flx w-100 justify-content-end align-items-end filtter_overview">
                        <div className="custom_input_flled mb-0">
                            <Form.Label>Region</Form.Label>
                            <Form.Select className="sm_input">
                                <option>All</option>
                                <option>APAC</option>
                                <option>EMEA</option>
                                <option>NA</option>
                            </Form.Select>
                        </div>
                        <div className="custom_input_flled mb-0">
                            <Form.Label>Cycle</Form.Label>
                            <input type="Date" className="form-control sm_input" />
                        </div>
                        <div className="custom_input_flled mb-0">
                            <Form.Label>Fiscal Year</Form.Label>
                            <Form.Select className="sm_input">
                                <option>All</option>
                                <option>APAC</option>
                                <option>EMEA</option>
                                <option>NA</option>
                            </Form.Select>
                        </div>
                        <Button variant="light">Sync Views</Button>
                    </div>
                </div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="budgetoverviewtab">
                    <div className="d-flex">
                        <Nav variant="pills" className="common_tab">
                            <Nav.Item>
                                <Nav.Link eventKey="budgetoverviewtab">Overview</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="budgeclaimstab">Claims</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="budgetremittancestab">Remittances (RA)</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="budgetreconciliationtab">Reconciliation</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="budgetreportstab">Reports</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="budgetconnectionstab">Connections</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Tab.Content className="common_content_inner mby_t_24">
                        <Tab.Pane eventKey="budgetoverviewtab">
                            <Budgetoverviewtab/>    
                        </Tab.Pane>
                        <Tab.Pane eventKey="budgeclaimstab">
                            <Budgeclaimstab/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="budgetremittancestab">
                            <Budgetremittancestab/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="budgetreconciliationtab">
                            <Budgetreconciliationtab/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="budgetreportstab">
                            <Budgetreporttab/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="budgetconnectionstab">
                            <Budgetconnectionstab/>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div >
        </>
    );
};

export default Budgetoverview;
